import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export function dateToNgbDate(date: any): NgbDate | null {
    return date instanceof Date
        ? new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
        : null
}

export function ngbDateToDate(date: any): Date | null {
    return date instanceof NgbDate || isNgbDate(date)
        ? new Date(Date.UTC(date.year, date.month - 1, date.day))
        : null
}

export function isNgbDate(date: any): boolean {
    return date !== null
        && date !== undefined
        && typeof date === 'object'
        && 'day' in date
        && 'month' in date
        && 'year' in date
        && Number.isInteger(date.day)
        && Number.isInteger(date.month)
        && Number.isInteger(date.year)
}

export function isNgbTime(time: any): boolean {
    return time !== null
        && time !== undefined
        && typeof time === 'object'
        && 'hour' in time
        && 'minute' in time
        && 'second' in time
        && Number.isInteger(time.hour)
        && Number.isInteger(time.minute)
        && Number.isInteger(time.second)
}

export function checkIfTimesAreEquals(time1: any, time2: any): boolean {
    const ngbTime1 = isNgbTime(time1)
    const ngbTime2 = isNgbTime(time2)

    if (!ngbTime1 || !ngbTime2) return false

    return time1.hour === time2.hour
        && time1.minute === time2.minute
        && time1.second === time2.second
}